type MemoryCacheEntry = {
    data: unknown;
    expiresAt: number;
};

const store = new Map<string, MemoryCacheEntry>();

export function memoryCacheKey(table: string, queryKey: string): string {
    return `${table}:${queryKey}`;
}

export function getMemoryCached<T>(table: string, queryKey: string): { data: T; expiresAt: number } | null {
    const entry = store.get(memoryCacheKey(table, queryKey));
    if (!entry) return null;
    return { data: entry.data as T, expiresAt: entry.expiresAt };
}

export function setMemoryCached(table: string, queryKey: string, data: unknown, expiresAt: number): void {
    store.set(memoryCacheKey(table, queryKey), { data, expiresAt });
}

export function clearMemoryCached(table: string, queryKey: string): void {
    store.delete(memoryCacheKey(table, queryKey));
}

export async function warmQueryMemoryFromDexie(
    entries: Array<{ table: string; queryKey: string }>,
): Promise<void> {
    const { db } = await import("@/lib/dexie-db");
    await Promise.all(
        entries.map(async ({ table, queryKey }) => {
            if (getMemoryCached(table, queryKey)) return;
            const tableRef = db[table as keyof typeof db];
            if (typeof tableRef === "object" && tableRef !== null && "where" in tableRef) {
                const result = await db.getCachedWithExpiry(
                    tableRef as Parameters<typeof db.getCachedWithExpiry>[0],
                    queryKey,
                );
                if (result) {
                    setMemoryCached(table, queryKey, result.data, result.expiresAt);
                }
            }
        }),
    );
}
